import { render, staticRenderFns } from "./DefiBorrow.vue?vue&type=template&id=3ed21b0f&"
import script from "./DefiBorrow.vue?vue&type=script&lang=js&"
export * from "./DefiBorrow.vue?vue&type=script&lang=js&"
import style0 from "./DefiBorrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports